import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// SEO Component
import { SEOHead } from "@/components/SEOHead";

// Scroll restoration on route change
import { ScrollToTop } from "@/components/ScrollToTop";

// Accessibility Widget
import { AccessibilityWidget } from "@/components/AccessibilityWidget";

// Cookie Consent Banner (Google Consent Mode v2 + PostHog gating)
import { CookieConsent } from "@/components/CookieConsent";

// Layout Components
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";

// Pages
import HomePage from "@/pages/HomePage";
import DoctorsPage from "@/pages/DoctorsPage";
import ContactPage from "@/pages/ContactPage";
import PatientResourcesPage from "@/pages/PatientResourcesPage";
import TreatmentAreasPage from "@/pages/TreatmentAreasPage";
import TreatmentDetailPage from "@/pages/TreatmentDetailPage";
import AccessibilityPage from "@/pages/AccessibilityPage";
import AreasWeServePage from "@/pages/AreasWeServePage";
import AreaDetailPage from "@/pages/AreaDetailPage";

function App() {
  return (
    <div className="min-h-screen bg-background font-body">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <SEOHead />
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/doctors" element={<DoctorsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/patient-resources" element={<PatientResourcesPage />} />
            <Route path="/treatment-areas" element={<TreatmentAreasPage />} />
            <Route path="/treatment-areas/:slug" element={<TreatmentDetailPage />} />
            <Route path="/areas-we-serve" element={<AreasWeServePage />} />
            <Route path="/areas-we-serve/:slug" element={<AreaDetailPage />} />
            <Route path="/accessibility" element={<AccessibilityPage />} />
          </Routes>
        </main>
        <Footer />
        <AccessibilityWidget />
        <CookieConsent />
      </BrowserRouter>
    </div>
  );
}

export default App;
